import CreditCard from './credit_card';
export class CreditCardIdentifierService {
    constructor() {
        'ngInject';
        this._card = new CreditCard();
    }

    set cardNumber(number) { this._card.number = number; }

    get card() { return this._card; }
    get issuingNetwork() { return this._card.issuingNetwork; }
    get cardNumber() { return this.card.number; }
    get lengths() { return this._card.lengths; }
    get mask() { return this._card.mask; }
    get name() { return this._card.name; }
    get securityCode() { return this._card.securityCode; }
    get securityCodeMask() { return this._card.securityCodeMask; }
    get valid() { return this._card.valid; }
}
